var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#3B98D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.075 15.55C11.9417 15.55 11.8127 15.525 11.688 15.475C11.5627 15.425 11.4583 15.3583 11.375 15.275L6.775 10.675C6.59167 10.4917 6.5 10.2583 6.5 9.975C6.5 9.69167 6.59167 9.45833 6.775 9.275C6.95833 9.09167 7.19167 9 7.475 9C7.75833 9 7.99167 9.09167 8.175 9.275L12.075 13.175L15.975 9.275C16.1583 9.09167 16.3917 9 16.675 9C16.9583 9 17.1917 9.09167 17.375 9.275C17.5583 9.45833 17.65 9.69167 17.65 9.975C17.65 10.2583 17.5583 10.4917 17.375 10.675L12.775 15.275C12.675 15.375 12.5667 15.4457 12.45 15.487C12.3333 15.529 12.2083 15.55 12.075 15.55Z",
    fill: "#F5F5F5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.105a61088e46dcf473de9344a0404aaf.svg";
export { ForwardRef as ReactComponent };